// extracted by mini-css-extract-plugin
export default {"build-item-option":"build-item-select_build-item-option__VgOKJ"};